<template>

    <b-card>

        <edit-user @refreshUserList="refreshUserList()" ref="modalEditUserC"></edit-user>

        <transaction-modal ref="userViewTransaction"></transaction-modal>

        <all-balance ref="allBalanceC"></all-balance>

        <b-row>

            <!-- User Info: Left col -->
            <b-col cols="21"
                   xl="6"
                   class="d-flex flex-column">

                <!-- User Avatar & Action Buttons -->
                <div class="d-flex justify-content-start align-items-center">

                    <b-avatar :src="userData.avatar"
                              :text="this.avatarText(userData.userName)"
                              :variant="`light-primary`"
                              size="104px"
                              rounded/>

                    <div class="d-flex flex-column ml-1">

                        <div class="mb-1">
                            <h4 class="mb-0">
                                {{ `${userData.userName}` }}
                            </h4>
                            <span class="card-text">{{ userData.email }}</span>
                        </div>

                        <div class="d-flex flex-wrap">

                            <b-button v-if="$can('edit','User')"
                                      @click="editUser()"
                                      variant="primary"
                                      size="sm">
                                {{$t('labels.edit')}}
                            </b-button>

                            <b-button  v-if="$can('delete','User')"
                                       @click="deleteUser()"
                                       variant="outline-danger"
                                       class="ml-1"
                                       size="sm">
                              {{ $t('labels.delete') }}
                            </b-button>

                        </div>
                    </div>
                </div>

                <!-- User Stats -->
                <div class="d-flex align-items-center mt-2">

<!--                    <div class="d-flex align-items-center mr-2">-->

<!--                        <b-avatar variant="light-primary"-->
<!--                                  rounded-->
<!--                                  size="70px">-->
<!--                            <feather-icon-->
<!--                                    icon="DollarSignIcon"-->
<!--                                    size="30"/>-->
<!--                        </b-avatar>-->

<!--                        <div class="ml-1">-->
<!--                            <h5 class="mb-0">-->
<!--                                {{selectedCurrency.symbol}} {{getBalance}}-->
<!--                            </h5>-->
<!--                            <small>Currency Balance</small>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="d-flex align-items-center">-->
<!--                        <b-avatar-->
<!--                                variant="light-success"-->
<!--                                rounded-->
<!--                                size="70px">-->

<!--                            <coin-avatar :abv="selectedCurrency.abv" variant="silver"></coin-avatar>-->
<!--                        </b-avatar>-->

<!--                        <div class="ml-1">-->

<!--                            <v-select v-model="selectedCurrency"-->
<!--                                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
<!--                                      :options="currencies"-->
<!--                                      style="min-width: 150px"-->
<!--                                      label="name"/>-->

<!--                            <small>Currency</small>-->

<!--                        </div>-->

<!--                    </div>-->

                </div>

            </b-col>

            <!-- Right Col: Table -->
            <b-col cols="12"
                   xl="6">

                <table class="mt-2 mt-xl-0 w-100">

                    <tr>
                        <th class="pb-50">
                            <feather-icon
                                    icon="CheckIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.status')}}</span>
                        </th>
                        <td class="pb-50 text-nowrap">
                            {{ userData.status ? $t("labels.activeStatus") : $t("labels.inactiveStatus") }}
                        </td>
                    </tr>

                    <tr>
                        <th class="pb-50">
                            <feather-icon
                                    icon="ShieldIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.role')}}</span>
                        </th>
                        <td class="pb-50 text-nowrap">
                            {{ userData.role ? userData.role : 'No role' }}
                        </td>
                    </tr>

                    <tr v-if="userData.userName">
                        <th class="pb-50">
                            <feather-icon
                                    icon="UserIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.userName')}}</span>
                        </th>
                        <td class="pb-50">
                            {{ `${userData.userName}` }}
                        </td>
                    </tr>

                    <tr v-if="userData.firstName">
                        <th class="pb-50">
                            <feather-icon
                                    icon="TagIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.firstName')}}</span>
                        </th>
                        <td class="pb-50">
                            {{ `${userData.firstName}` }}
                        </td>
                    </tr>

                    <tr v-if="userData.lastName">
                        <th class="pb-50">
                            <feather-icon
                                    icon="TagIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.lastName')}}</span>
                        </th>
                        <td class="pb-50">
                            {{ `${userData.lastName}` }}
                        </td>
                    </tr>

                    <tr v-if="userData.wallet">
                        <th class="pb-50">
                            <feather-icon
                                    icon="CreditCardIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.wallet')}}</span>
                        </th>
                        <td class="pb-50">
                            <b-badge :to="{ name: 'wallets-detail', params: { id: userData.wallet._id } }"
                                     variant="primary">{{ `${userData.wallet._id}` }}</b-badge>
                        </td>
                    </tr>

                    <tr v-if="userData.email">
                        <th class="pb-50">
                            <feather-icon
                                    icon="AtSignIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.email')}}</span>
                        </th>
                        <td class="pb-50">
                            {{ `${userData.email}` }}
                        </td>
                    </tr>

                    <tr v-if="userData.client">
                        <th class="pb-50">
                            <feather-icon
                                    icon="LayersIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.client')}}</span>
                        </th>
                        <td class="pb-50">
                            {{ `${userData.client.name}` }}
                        </td>
                    </tr>

                    <tr @click="showUserTransaction(userData)">
                        <th class="pb-50">
                            <feather-icon
                                    icon="BookmarkIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.userOperations')}}</span>
                        </th>
                        <td class="pb-50">
                            <b-button variant="danger" size="sm" class="d-flex flex-row ">
                                <span>{{$t('buttons.showOperations')}}</span>
                            </b-button>
                        </td>
                    </tr>

                  <tr @click="showUserAllBalance(userData)">
                    <th class="pb-50">
                      <feather-icon
                          icon="ListIcon"
                          class="mr-75"
                      />
                      <span class="font-weight-bold">{{$t('labels.userBalances')}}</span>
                    </th>
                    <td class="pb-50">
                      <b-button variant="success" size="sm" class="d-flex flex-row ">
                        <span>{{$t('buttons.showBalances')}}</span>
                      </b-button>
                    </td>
                  </tr>

                </table>
            </b-col>

        </b-row>

    </b-card>

</template>

<script>
  import { avatarText } from '@/@core/utils/filter'
  import { BAvatar, BButton, BCard, BCol, BRow , BBadge} from 'bootstrap-vue'
  import EditUser from './EditUser'
  import { mapActions } from 'vuex'
  import TransactionModal from '../shared/TransactionModal'
  import CoinAvatar from '../currencies/CoinAvatar'
  import vSelect from 'vue-select'
  import AllBalance from "@/views/dashboard/shared/AllBalance";

  export default {
    name: 'UserViewUserInfoCard',
    components: {
      AllBalance,
      BCard, BButton, BRow, BCol, BAvatar,EditUser,BBadge,TransactionModal,CoinAvatar,vSelect
    },

    props: {
      userData: {
        type: Object,
        required: true,
      },
    },

    setup() {
      return {
        avatarText,
      }
    },

    data(){
      return{
        selectedCurrency : '',
        currencies : [],
        defaultCurrency : ''
      }
    },

    methods: {
      ...mapActions('user', ['destroy']),
      ...mapActions('currency', ['currencys']),
      ...mapActions("wallet", ["show"]),

      showUserTransaction(user){
        this.$refs.userViewTransaction.showModal(user,this.defaultCurrency,this.currencies,'USER')
      },

      showUserAllBalance(user){
        this.$refs.allBalanceC.showAllBalanceModal(user,'USER')
      },

      async editUser(){
        const formData = JSON.parse(JSON.stringify(this.userData))
        delete formData.password
        if (formData.hasOwnProperty('wallet'))
          formData.wallet = formData.wallet._id
        await this.$refs.modalEditUserC.showModal(formData)
      },

      async deleteUser() {
        this.$swal({
          title: this.$t('labels.areYouSure'),
          text: this.$t('labels.notRevert'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('labels.yesDelete'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
          .then(async result => {
            if (result.value) {
              let response = await this.destroy(this.userData._id)
              if(response){
                this.refreshUserList()
                this.$swal({
                  icon: 'success',
                  title: this.$t('labels.deleted'),
                  text: response.message,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            }
          })
      },

      refreshUserList() {
        this.$router.push({ name: 'users' })
      },

      getWalletCurrencies(walletData){
        return walletData.currencies.map(currencies => {
          return Object.assign({}, currencies.currency)
        })
      },

    },

    async created() {
      let wallet = ''
      if (this.userData.hasOwnProperty('wallet')){
        wallet = await this.show(this.userData.wallet._id)
      }else {
        wallet = await this.show(this.userData.client.wallet)
      }
      if (wallet){
        this.currencies = this.getWalletCurrencies(wallet).filter(currency => currency.status)
        this.defaultCurrency = wallet.defaultCurrency
      }
    }

  }
</script>

<style>
</style>
